import { Route } from '@angular/router';
import { ContentLayoutComponent } from './shared/layouts/content-layout/content-layout.component';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { BlankLayoutComponent } from './shared/layouts/blank/blank-layout.component';
import { AssessmentLayoutComponent } from './shared/layouts/assessment-layout/assessment-layout.component';

import { auth } from './routes/auth.routes';
import { content } from './routes/content.routes';
import { guest } from './routes/guest.routes';
import { soarAi } from './routes/soar-ai.routes';

import { authGuard } from './guards/auth.guard'; // Importa o AuthGuard para proteger rotas privadas

export const App_Route: Route[] = [
  /* IMPORTANTE:
   Use o canActivate: [authGuard] na rota para garantir que apenas
   usuários autenticados acessem essas páginas.
  */

  { path: '', redirectTo: 'auth/login', pathMatch: 'full' }, // Redireciona a raiz do sistema para a tela de login
  { path: '', component: AuthenticationLayoutComponent, children: auth }, // Define as rotas de autenticação (Login, Cadastro, Recuperação de senha, etc.)
  { path: '', component: ContentLayoutComponent, children: content, canActivate: [authGuard] }, // Define as rotas protegidas dentro do layout principal da aplicação
  { path: '', component: BlankLayoutComponent, children: guest }, // Define as rotas públicas acessíveis sem autenticação (páginas abertas ao público)
  { path: '', component: BlankLayoutComponent, children: soarAi },

  // Telas de avaliação (sem sidebar, tela cheia)
  {
    path: '',
    component: AssessmentLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'guest/welcome',
        loadComponent: () => import('./guest/assessment/guest-assessment.component').then((m) => m.GuestAssessmentComponent),
        data: { mode: 'guest' },
      },
      {
        path: 'guest/assessment',
        loadComponent: () => import('./guest/assessment/guest-assessment.component').then((m) => m.GuestAssessmentComponent),
        data: { mode: 'assessment' },
      },
      {
        path: 'assessment/welcome',
        loadComponent: () => import('./guest/welcome/guest-welcome.component').then((m) => m.GuestWelcomeComponent),
        data: { mode: 'guest' },
      },
      {
        path: 'assessment/questions',
        loadComponent: () => import('./guest/assessment/guest-assessment.component').then((m) => m.GuestAssessmentComponent),
        data: { mode: 'assessment' },
      },
    ],
  },
];
